import styled from "styled-components";

export const StyledErrorReportPage = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	min-height: 0;

	> * {
		flex-shrink: 0;
	}

	.breadBlock {
		display: flex;
		padding: 8px 0;
	}

	.searchToolBar {
		display: flex;
		flex-direction: column;
		row-gap: 10px;
		margin-bottom: 10px;
	}

	.searchRow {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		row-gap: 10px;

		> div {
			margin-right: 8px;
			width: 150px;
		}

		/* Select 元件自帶 min-width: 120px，需清掉才能設得比 120px 窄 */
		> div.w70 {
			min-width: 0;
			width: 70px;
		}

		> div.w100 {
			min-width: 0;
			width: 100px;
		}

		> div.w120 {
			width: 120px;
		}

		> div.cmsInput {
			width: 100px;
		}

		> div.dateFilter {
			width: 250px;
		}

		> div.descriptionInput {
			width: 200px;
		}

		> div.searchBtn {
			width: 130px;
		}

		> div.errorTypeFilter {
			width: 170px;

			> div {
				width: 100%;
			}

			.header {
				box-sizing: border-box;
				align-items: center;
				height: 32px;
				padding: 0 11px;
				font-size: 14px;
				color: rgba(0, 0, 0, 0.85);
				background-color: #fff;
				border: 1px solid #d9d9d9;
				border-radius: 2px;
				transition: border-color 0.3s;

				&:hover {
					background-color: #fff;
					border-color: #40a9ff;
				}

				> .title {
					min-width: 0;
					overflow: hidden;
					white-space: nowrap;

					> span:first-child {
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}

				> .icon {
					margin-left: 4px;

					> div {
						color: rgba(0, 0, 0, 0.25);

						> * {
							font-size: 16px;
						}
					}
				}
			}
		}
	}

	.countText {
		padding: 10px 0;
		color: #fff;

		> span {
			font-size: 20px;
			font-weight: 700;
		}

		> span.totalCount {
			margin-left: 4px;
			font-size: 16px;
			font-weight: 400;
			color: #a1a4b1;
		}
	}

	> .errorReportTable {
		flex: 1 1 0;
		min-height: 240px;
	}

	.checkboxItem {
		min-width: 30px;
	}

	.previewItem {
		min-width: 100px;

		.previewImage {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 84px;
			height: 56px;
			color: #fff;
			background-color: #c4c4c4;
			flex-shrink: 0;

			.ant-image {
				width: 100%;
				height: 100%;
			}

			.ant-image-img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
	}

	.comeFromItem {
		white-space: nowrap;
	}

	.actionItem {
		min-width: 110px;
	}

	.descriptionItem {
		white-space: pre-line;
		word-break: break-word;
	}

	.reporterInfoItem {
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		word-break: break-all;
	}

	.remarkItem {
		column-gap: 8px;

		.remarkText {
			white-space: pre-line;
			word-break: break-word;
		}
	}

	.errorTypeItem {
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		white-space: nowrap;
	}

	.timeItem {
		min-width: 120px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
	}

	.productItem {
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		row-gap: 4px;
		min-width: 80px;
	}

	.mailItem {
		min-width: 60px;

		i {
			font-size: 24px;
		}
	}

	.tag {
		padding: 1px 8px;
		font-size: 13px;
		white-space: nowrap;
		color: #fff;
		border-radius: 2px;

		&.online {
			background-color: #4caf50;
		}

		&.offline {
			background-color: #ff4d4f;
		}
	}

	/* 狀態底色對齊設計稿：待審核=藍、待修改=橘、已完成=綠 */
	.statusTag {
		padding: 2px 10px;
		font-size: 13px;
		white-space: nowrap;
		color: #fff;
		border-radius: 2px;

		&.Waiting {
			background-color: #1890ff;
		}

		&.ModifyWaiting {
			background-color: #ffb800;
		}

		&.ProgramFixWaiting {
			background-color: #ffb800;
		}

		&.CheckWaiting {
			background-color: #1890ff;
		}

		&.Finish {
			background-color: #4caf50;
		}
	}

	.loading {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
	}

	.tableNoData {
		margin: 24px auto;
		width: 50%;
		font-size: 24px;
		text-align: center;
		color: #fff;
	}

	.buttonGroup {
		display: flex;
		justify-content: flex-end;
		margin: 12px 0 30px;

		.btn {
			margin-left: 8px;
		}
	}
`;

export const UiPopupContainer = styled.div`
	.ant-image-preview-img-wrapper::before {
		height: 10%;
	}

	.ant-image-preview-img {
		margin: auto;
		width: auto;
		max-width: 70vw;
		max-height: 90vh;
	}
`;
